import {createContext, useContext} from 'react';
import type {ChecklistStep} from './useChecklistSteps';

export interface HomeData {
  bookingRef: string;
  navItems: ChecklistStep[];
  navLoading: boolean;
  checkInDate?: string;
  checkInTime?: string;
  checkOutDate?: string;
  checkOutTime?: string;
  nights?: number;
  guests?: number;
  propertyName?: string;
}

export const HomeDataContext = createContext<HomeData | null>(null);

export function useHomeData() {
  const ctx = useContext(HomeDataContext);
  if (!ctx) throw new Error('useHomeData must be used within a HomeDataProvider');
  return ctx;
}
